export const STORE_KEY = '$_library';

export const GET_CLASSES = 'GET_CLASSES';
export const LESSON_PLAN_TYPE = 1;
export const SET_PARAMS_SEARCH_LESSONS = 'SET_PARAMS_SEARCH_LESSONS';
export const TAB_MEDIA_PAGE_LINK = 1;
export const TAB_LESSON = 2;
export const TAB_ACTIVE_LEARNING = 3;
export const TYPE_PAGE_LINK_LOAD = 'hoclieu';
export const TYPE_LESSON_LOAD = 'baigiang';
export const TYPE_ACTIVE_LEARN_LOAD = 'hocchudong';
export const LOCAL_BREADCRUMB_ALL = 'breadAll';
export const DETAIL_TAB_INFO = 'info';
export const DETAIL_TAB_DOWNLOAD = 'download_tab';
export const HANDLE_ACTICE_BOOK_SUCCESS = 'HANDLE_ACTICE_BOOK_SUCCESS';
export const ID_MODAL_ACTIVE_BOOK = 'lib_active_book';
export const ID_MODAL_READ_LINK_TYPE = 'modal_link_type';
export const SET_PARAMS_FILTER_BOOK = 'SET_PARAMS_FILTER_BOOK';
export const SET_PARAMS_FILTER_BOOK_LESSON = 'SET_PARAMS_FILTER_BOOK_LESSON';
export const SET_BOOK_PAGE_LINK_FILTER_RESULT = 'SET_BOOK_PAGE_LINK_FILTER_RESULT';
export const SET_BOOK_LESSON_FILTER_RESULT = 'SET_BOOK_LESSON_FILTER_RESULT';
export const SET_PARAMS_ACTIVE_LEARNING = 'SET_PARAMS_ACTIVE_LEARNING'
export const SET_BOOK_ACTIVE_LEARNING = 'SET_BOOK_ACTIVE_LEARNING'
export const ID_MODAL_SHARE = 'share_media_modal';
export const ID_MODAL_SHARE_MAIL = 'share_modal_mail';
export const RESET_STATE = 'RESET_STATE';
